import React, { Component } from "react";
import actions from '../actions';
import buildingActions from '../../buildings/actions';
import { connect } from 'react-redux';
import VisitsPage from '../components/VisitsPage';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import { I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import PlannedVisitorsOrHistoricPage from "../components/PlannedVisitorsOrHistoricPage";

class VisitsPageContainer extends Component {
    constructor(props) {
        super(props);
        const { isVisitsHistoric } = props;
        this.state = {
            universalSearchField: "",
            defaultSort: {
                property : "expectedCheckInTimestamp",
                direction : "ASC"
            },
            alert: {
                show: false
            },
            searchFieldsValues: {
                visitorName: {
                    value: ""
                },
                checkedOut: {
                    value: isVisitsHistoric ?
                        [true] :
                        undefined
                },
                visitHost: {
                    value: ""
                },
                buildingId: {
                    value: ""
                },
                meetingId: {
                    value: ""
                }
            }
        }
    };

    componentDidMount() {
        const { getBuildingList } = this.props;

        this.fetchData();
        getBuildingList({
            hasCheckInConfiguration: true
        });
    };

    componentWillReceiveProps(nextProps) {
        const {
            loadingCheckOutRequest : currentLoadingCheckOut,
            loadingCheckInRequest : currentLoadingCheckIn,
        } = this.props;

        const {
            loadingCheckOutRequest : nextLoadingCheckOut,
            loadingCheckInRequest : nextLoadingCheckIn,
            checkOutRequestSuccess,
            checkInRequestSuccess,
            error
        } = nextProps;

        //Handle Error, Edit and Create
        if (currentLoadingCheckOut && !nextLoadingCheckOut) {
            if (checkOutRequestSuccess) {
                this.handleCheckInOrOutSuccess('checkOut');
            } else {
                this.handleCheckInOrOutError('checkOut', error);
            }
        } else if (currentLoadingCheckIn && !nextLoadingCheckIn) {
            if (checkInRequestSuccess) {
                this.handleCheckInOrOutSuccess('checkIn');
            } else {
                this.handleCheckInOrOutError('checkIn', error);
            }
        }
    };
    
    componentWillUnmount() {
        this.props.resetVisitsTable();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        const {
            searchFieldsValues,
            universalSearchField,
            defaultSort
        } = this.state;

        const {
            isPlannedVisits,
            isVisitsHistoric,
        } = this.props;

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return _.isNilOrEmpty(keyValuePair[1].value) ?
                { ...acc } : { ...acc, [keyValuePair[0]]: keyValuePair[1].value }
        }, {});

        if (!_.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchVisits({
            ...filter,
            status: isPlannedVisits ?
                'PENDING' :
                isVisitsHistoric ?
                    undefined :
                    'CHECKED_IN',
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: (isPlannedVisits && _.isNilOrEmpty(sortProperty)) ? defaultSort.property : sortProperty,
            sortDirection: (isPlannedVisits && _.isNilOrEmpty(sortDirection)) ? defaultSort.direction : sortDirection
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleUniversalSearchFieldChange = value => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    };

    handleSortChanged = newSort => {
        const {
            table: {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc ? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    };

    handleCheckoutClicked = selectedEntries => {
        this.props.checkOutSelectEntries(selectedEntries);
    };
    
    handleCheckInClicked = selectedEntries => {
        this.props.checkInSelectedEntries(selectedEntries);
    };

    handleAddButtonClicked = () => {
        this.props.history.push('/currentVisits/create');
    };

    handleCheckInOrOutSuccess = successKey => {
        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('visits.alerts.' + successKey + '.success.title'),
                html: I18n.t('visits.alerts.' + successKey + '.success.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: () => this.hideAlert(),
                onConfirm: () => this.hideAlert(this.fetchData)
            }
        })
    }

    handleCheckInOrOutError = (errorKey, error) => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('visits.alerts.' + errorKey + '.error.title'),
                html: I18n.t('visits.alerts.' + errorKey + '.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: () => this.hideAlert()
            }
        })
    };

    hideAlert = (afterAlertIsHidden = () => { }) => {
        this.setState({
            alert: {
                show: false
            }
        }, afterAlertIsHidden)
    };

    render() {
        const { searchFieldsValues, universalSearchField, alert } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            loadingCheckoutRequest,
            isPlannedVisits,
            isVisitsHistoric,
            buildingList
        } = this.props;

        return (
            isPlannedVisits || isVisitsHistoric ?
                <PlannedVisitorsOrHistoricPage
                    alert={{
                        ...alert,
                        loading: loadingCheckoutRequest
                    }}

                    searchFieldsValues={searchFieldsValues}
                    universalSearchField={universalSearchField}
                    buildingList={buildingList}

                    handleSearchFieldChange={this.handleSearchFieldChange}
                    handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                    handleSearchSubmit={this.handleSearchSubmit}
                    handleSearchClear={this.handleSearchClear}
                    handleSortChanged={this.handleSortChanged}

                    data={data}
                    sort={sort}
                    totalElements={totalElements}
                    pages={pages}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onPageChange={this.onPageChange}
                    onPageSizeChange={this.onPageSizeChange}

                    isHistoric={isVisitsHistoric}

                    handleCheckInClicked={this.handleCheckInClicked}
                /> :
                <VisitsPage
                    alert={{
                        ...alert,
                        loading: loadingCheckoutRequest
                    }}

                    searchFieldsValues={searchFieldsValues}
                    universalSearchField={universalSearchField}
                    buildingList={buildingList}

                    handleSearchFieldChange={this.handleSearchFieldChange}
                    handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                    handleSearchSubmit={this.handleSearchSubmit}
                    handleSearchClear={this.handleSearchClear}
                    handleSortChanged={this.handleSortChanged}
                    data={data}
                    sort={sort}
                    totalElements={totalElements}
                    pages={pages}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onPageChange={this.onPageChange}
                    onPageSizeChange={this.onPageSizeChange}

                    handleAddButtonClicked={this.handleAddButtonClicked}
                    handleCheckoutClicked={this.handleCheckoutClicked}
                />
        );
    }
}

const mapStateToProps = ({ 
    visitsReducer,
    buildingsReducer
}) => {
    return {
        table: visitsReducer.table,

        loadingCheckOutRequest: visitsReducer.loadingCheckOutRequest,
        loadingCheckInRequest: visitsReducer.loadingCheckInRequest,

        checkOutRequestSuccess: visitsReducer.checkOutRequestSuccess,
        checkInRequestSuccess: visitsReducer.checkInRequestSuccess,
        
        buildingList: buildingsReducer.buildingList
    };
};

const mapDispatchToProps = {
    resetVisitsTable: actions.resetVisitsTable,
    searchVisits: actions.searchVisits,
    checkOutSelectEntries: actions.checkOutSelectEntries,
    checkInSelectedEntries: actions.checkInSelectedEntries,
    getBuildingList: buildingActions.getBuildingList
};

VisitsPageContainer.propTypes = {
    isPlannedVisits: PropTypes.bool,
    isVisitsHistoric: PropTypes.bool,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisitsPageContainer);
